var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.106 5.39806C14.6688 5.68626 15.3312 5.68626 15.894 5.39806L19.553 3.52281C19.8632 3.36396 20.2316 3.38115 20.5265 3.56824C20.8213 3.75533 21.0005 4.0856 21 4.44097V17.5206C20.9998 17.9086 20.7857 18.2632 20.447 18.4367L15.894 20.77C15.3312 21.0582 14.6688 21.0582 14.106 20.77L9.894 18.6119C9.33118 18.3237 8.66882 18.3237 8.106 18.6119L4.447 20.4872C4.13662 20.6461 3.76802 20.6288 3.47312 20.4415C3.17821 20.2541 2.99914 19.9235 3 19.568V6.4894C3.0002 6.10137 3.21427 5.74674 3.553 5.57329L8.106 3.23999C8.66882 2.95179 9.33118 2.95179 9.894 3.23999L14.106 5.39806Z",
    stroke: "#666666",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 5.76001V20.76",
    stroke: "#666666",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 3.23999V18.24",
    stroke: "#666666",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapp);
export default __webpack_public_path__ + "static/media/mapp.6dc72c9b04761118475f7416e557ae66.svg";
export { ForwardRef as ReactComponent };